// extracted by mini-css-extract-plugin
module.exports = {"zoom-controls":"a2c79c7e7d--zoom-controls--B8Yre","plus-button":"a2c79c7e7d--plus-button--Jy5pT","minus-button":"a2c79c7e7d--minus-button--Ma3QP"};